import { IAuthState, ILoginState, IUserType } from './types/authTypes';
import { consts } from '../../common/consts';
import { parseJwt } from '../../common/helpers';
import { login } from '../../store/modules/authSlice';
import { amountActiveSessionExceeded } from '../../common/phrases';

const getRoles = (authStore: IAuthState): IUserType => {
    const roles: IUserType = {
        IsAdmin: authStore?.data?.IsAdmin || false,
        SMADriver: authStore?.data ? authStore?.data?.role?.indexOf(consts.Permissions.SMADriver) >= 0 ? true : false : false,
        CanViewDashboard: authStore?.data?.role?.split(',')?.some(p => p === consts.Permissions.SMAAdminPatientTransportDashboard || p === consts.Permissions.ViewDashboard) ?? false,
        CustomerDriver: authStore?.data ? authStore?.data?.role?.indexOf(consts.Permissions.CustomerDriver) >= 0 ? true : false : false,
    }
    return roles;
}


const formatToken = (token: string): IAuthState => {
    let tokenObject = parseJwt(token);
    let tempAuthData: IAuthState = {
        isAuthenticated: true,
        token: token,
        userName: null,
        sessionExpired: false,
        vehicleSessionId: null,
        vehicleNumber: null,
        appId: tokenObject.AppId,
        data: {
            givenName: String(tokenObject.given_name),
            surName: String(tokenObject.family_name),
            email: String(tokenObject.email),
            role: String(tokenObject.role),
            IsAdmin: tokenObject.IsAdmin === "True",
            exp: tokenObject.exp,
            location: String(tokenObject.location),
            ward: String(tokenObject.ward),
            IsSMAUser: tokenObject.IsSMAUser === "True"
        }
    };
    return tempAuthData;
}


const signIn = async (data: any,
    dispatch: any,
    finishLogin: any,
    goToLoginOTP: any,
    setErrorMessage: any
): Promise<void> => {
    try {
        setErrorMessage("");
        const result = await dispatch(login(data.email, data.password));
        if (result.result == 2) {
            finishLogin(true, result.token ?? "");
        }
        else if (result.result == 3) {
            goToLoginOTP(data.email, data.password, false);
        }
        else if (result.result == 6) {
            goToLoginOTP(data.email, data.password, true);
        }
        else if (result.result == 7) {
            setErrorMessage("OTP can't be sent.");
        }
        else if (result.result == 1) {
            setErrorMessage("Sign-in is blocked\nYou've tried to sign in too many times with an incorrect account or password.");
        }
        else if (result.result == 4) {
            setErrorMessage("Your account is disabled at this time. For more information, please contact us on 1300 30 40 63");
        }
        else if (result.result == 9) {
            setErrorMessage(amountActiveSessionExceeded);
        }
        else if (result.result == 8) {
            setErrorMessage("Account disabled");
        }
        else {
            setErrorMessage("Username or password is invalid.");
        }
    } catch (error) {
        console.log(error);
        setErrorMessage("Something went wrong.");
    }

}

export {
    getRoles,
    formatToken,
    signIn
}
